/**
 * 组件信息
 */
export const info = {
  name: 'xy-dialog', // 组件名
  type: 'component-plus', // 组件类型
  label: '弹框', // 组件label
  icon: 'icon-xy-dialog', // 组件图标
  defaultWidth: 0, // 组件默认宽度
  defaultHeight: 0 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: {},
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [{}]
